import React from 'react';

type TitleProps = {
  className?: string;
  children: React.ReactNode;
};

function Title({className, children}: TitleProps) {
  return (
    <h3 className={`text-2xl font-semibold ${className || ''}`}>{children}</h3>
  );
}

type SubTitleProps = {
  className?: string;
  children: React.ReactNode;
};

Title.Sub = function SubTitle({className, children}: SubTitleProps) {
  return (
    <div className={`mb-8 text-eclipse ${className || ''}`}>{children}</div>
  );
};

export default Title;
